export function getRecaptcha(type) {
    if (type === 'v3') {
        let url = new URL(document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]').src);
        let params = new URLSearchParams(url.search);
        return grecaptcha.execute(params.get('render'));
    }
    if (type === 'enterprise') {
        let url = new URL(document.querySelector('script[src^="https://www.google.com/recaptcha/enterprise.js"]').src);
        let params = new URLSearchParams(url.search);
        return grecaptcha.enterprise.execute(params.get('render'));
    }
}

export async function setRecaptchaResponse(form) {
    if ($(form).data('recaptcha') && !$(form.elements).filter('.g-recaptcha-response').length) {
		let fieldName = typeof $(form).data('recaptcha') == 'string' ? $(form).data('recaptcha') : 'g-recaptcha-response';
        $(form).append(`<input type="hidden" name="${fieldName}" class="g-recaptcha-response">`);
    }
    const $recaptchaField = $(form.elements).filter('.g-recaptcha-response');
    if ($recaptchaField.length) {
        const type = $recaptchaField.data('recaptcha-type') || 'v3'; // domyślnie v3
        $(form.elements).filter('.g-recaptcha-response').val(await getRecaptcha(type));
    }
};